import React from 'react';
import { Reveal } from './Reveal';
export function ClosingWords() {
  return <section className="bg-paper px-5 py-20 sm:py-24 lg:px-8" aria-labelledby="cierre" data-id="element-36" data-mp="3mutkpvwullhx">
      <Reveal className="mx-auto max-w-3xl" data-id="element-37" data-mp="3mt0bc8uuon68">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-38" data-mp="3hup7cer8l6vx">
          Para cerrar
        </p>
        <h2 id="cierre" className="display mt-4 text-3xl text-ink sm:text-5xl" data-id="element-39" data-mp="3dtvgpdmetdzc">
          Dejá de improvisar. Empezá a construir.
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-40" data-mp="344ln1tbx3n94">
          Pasaste años aprendiendo de fútbol en la cancha. Merecés un sistema de
          trabajo que esté a la altura de lo que sabés.
        </p>
        <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-41" data-mp="2u6xhs9goqxcp">
          Sumate a los 2.500+ profes que hoy planifican todo su año en menos de cinco
          minutos.
        </p>
        <p className="display mt-8 text-2xl text-ink sm:text-3xl" data-id="element-42" data-mp="2l5pxivb07x1m">
          Basta de caos. Empezá con el sistema.
        </p>
      </Reveal>
    </section>;
}